import { Avatar } from "@mui/material";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { BsArrowLeft } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { postForgotPassword } from "../redux/features/LoginSlice";

const ForgotPassword = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.login.isLoading);

  return (
    <div className="min-h-[calc(100vh)] flex items-center justify-center bg-gray-100 bg-register_bg bg-no-repeat bg-cover">
      <div className="p-6 bg-opacity-15 backdrop-blur-[1] bg-white shadow-lg rounded-xl md:w-[25rem] w-[90%]">
        <div className="flex flex-col gap-2 justify-center items-center">
          <Avatar sx={{ width: 100, height: 100 }} />
          <h2 className="text-xl font-medium text-white">Forgot Password</h2>
        </div>
        <Formik
          initialValues={{ email: "" }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email("Invalid email address")
              .required("Required"),
          })}
          onSubmit={(values) => {
            dispatch(
              postForgotPassword({
                data: {
                  email: values.email,
                },
              })
            );
          }}
        >
          <Form className="space-y-7 mt-5">
            <div className="">
              <h2 className="text-base text-white">Email</h2>
              <Field
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                placeholder="Enter your email"
                className="py-3 px-3 rounded-md border border-gray-300 w-full hover:border-black duration-200"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500 text-sm"
              />
            </div>
            <button
              type="submit"
              className="w-full flex justify-center hover:bg-white hover:border-black hover:text-black duration-500 rounded-full py-3 px-4 border border-transparent text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
              disabled={isLoading}
            >
              {isLoading ? "Sending..." : "Send Reset Link"}
            </button>
          </Form>
        </Formik>

        <div className="text-sm text-center mt-4">
          <Link
            to="/login"
            className="flex items-center gap-2 font-medium text-white"
          >
            <BsArrowLeft /> Back to Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
